<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(false);
  pagingStore.showNext(false);
  function foo() {
    pagingStore.load("cover");
  }

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(false);
  laraStore.setOpacity(0);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("white");
  stylesColor.set("black");
</script>

<Quote title="Ende">
  Tschüss
  <button on:click={foo} class="block mt-5 p-5 rounded-md bg-gray-400">
    restart
  </button>
</Quote>
